var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.domVisible,
        "custom-class": _vm.dialogClass,
        "close-on-click-modal": false,
        "lock-scroll": false,
        "before-close": _vm.closeDialog
      },
      on: {
        "update:visible": function($event) {
          _vm.domVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ]
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.ruleForm, rules: _vm.rules }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "mobile" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "login_ipt",
                      attrs: { placeholder: _vm.$t("verify.PhoneNumber1") },
                      on: {
                        input: function($event) {
                          return _vm.setInput()
                        }
                      },
                      model: {
                        value: _vm.ruleForm.mobile,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "mobile", $$v)
                        },
                        expression: "ruleForm.mobile"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "prepend" },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.ruleForm.nationCode))]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "login_flag",
                              attrs: {
                                placeholder: _vm.$t("SelectCountryRegion")
                              },
                              on: { change: _vm.changeLocation },
                              model: {
                                value: _vm.ruleForm.nationCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "nationCode", $$v)
                                },
                                expression: "ruleForm.nationCode"
                              }
                            },
                            _vm._l(_vm.nationList, function(item, index) {
                              return _c(
                                "el-option",
                                {
                                  key: index,
                                  attrs: {
                                    label: item.NationCode,
                                    value: item.NationCode
                                  }
                                },
                                [
                                  _c("div", { staticClass: "locationOption" }, [
                                    _c("img", { attrs: { src: item.IconUrl } }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$i18n.locale != "zh"
                                            ? item.EnName
                                            : item.ChName
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "password" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "login_ipt",
                      attrs: {
                        type: _vm.flagType,
                        maxlength: "20",
                        placeholder: _vm.$t("verify.Password")
                      },
                      on: {
                        input: function($event) {
                          return _vm.setInput()
                        }
                      },
                      model: {
                        value: _vm.ruleForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "password", $$v)
                        },
                        expression: "ruleForm.password"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "showing",
                        class: [_vm.flag == true ? "show" : "noshow"],
                        attrs: { slot: "suffix" },
                        on: {
                          click: function($event) {
                            return _vm.getFlag()
                          }
                        },
                        slot: "suffix"
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "login_btn",
                  attrs: { disabled: _vm.disabled, type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SignIn")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { label: _vm.$t("RememberMe"), name: "type" },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [
                      _c(
                        "i18n",
                        {
                          staticClass: "userText",
                          attrs: { path: "agreeTo", tag: "div" }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "text_blue",
                              attrs: {
                                to: { path: "/useragreement" },
                                target: "_blank"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("UserAgreement")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "text_blue",
                              attrs: {
                                to: { path: "/privacyagreement" },
                                target: "_blank"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("PrivacyPolicy")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tips" }, [
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.godialog("forgot", "login")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("ResetPassword")))]
                    ),
                    _vm._v(" "),
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.godialog("register", "login")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SignUp")))]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67412af2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67412af2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/login.vue
// module id = null
// module chunks = 